export const TRACKING_STRINGS = {
  es: {
    hello: "Hola",
    receiveNotifs: "Recibe notificaciones",
    notifDesc: "Te avisamos cuando tu pedido esté cerca",
    activate: "Activar",
    notifsEnabled: "Notificaciones activadas",
    eta: "Tiempo estimado de llegada",
    driverOnWay: "está en camino",
    orderDelivered: "Pedido entregado",
    thanksForBuying: "¡Gracias por tu compra!",
    rateExperience: "Evalúa tu experiencia",
    orderStatus: "Estado del pedido",
    liveTracking: "Seguimiento en vivo",
    realtime: "En tiempo real",
    yourDriver: "Tu repartidor",
    orderDetails: "Detalles del pedido",
    order: "Pedido",
    items: "Artículos",
    products: "producto(s)",
    address: "Dirección",
    total: "Total",
    loading: "Cargando...",
    orderNotFound: "Pedido no encontrado",
    linkExpired: "El enlace puede haber expirado",
    poweredBy: "Desarrollado por",
  },
  pt: {
    hello: "Olá",
    receiveNotifs: "Receba notificações",
    notifDesc: "Avisamos quando o seu pedido estiver próximo",
    activate: "Ativar",
    notifsEnabled: "Notificações ativadas",
    eta: "Tempo estimado de chegada",
    driverOnWay: "está a caminho",
    orderDelivered: "Pedido entregue",
    thanksForBuying: "Obrigado pela sua compra!",
    rateExperience: "Avalie a sua experiência",
    orderStatus: "Estado do pedido",
    liveTracking: "Rastreamento ao vivo",
    realtime: "Em tempo real",
    yourDriver: "O seu entregador",
    orderDetails: "Detalhes do pedido",
    order: "Pedido",
    items: "Itens",
    products: "produto(s)",
    address: "Morada",
    total: "Total",
    loading: "A carregar...",
    orderNotFound: "Pedido não encontrado",
    linkExpired: "O link pode ter expirado",
    poweredBy: "Desenvolvido por",
  },
};

export function detectTrackingLang(restaurantLocale) {
  if (restaurantLocale) {
    if (restaurantLocale.startsWith("pt")) return "pt";
    return "es";
  }
  return "es";
}
